import { Action, Module, VuexModule } from "vuex-module-decorators";
import { EmployeeStatusLog } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class EmployeeStatusLogModule extends VuexModule {
    @Action
    [EmployeeStatusLog.getEmployeeStatusLogList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/log/status/employees/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [EmployeeStatusLog.findPageEmployeeStatusLog](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/log/status/employees`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [EmployeeStatusLog.saveEmployeeStatusLog](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/log/status/employees/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

        @Action
    [EmployeeStatusLog.deleteEmployeeStatusLog](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/log/status/employees/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}